import React, { useState } from "react";
import "../Css/contact-us.css";
import contactImg from "../Img/Contact-us/Contact-img.jpg";
import Linkedin from "../Img/Final-images/linkedin.png";
import BannerImg from "../Img/Final-images/contact-banner-img.png";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";
import { LuMapPin } from "react-icons/lu";
import { CiFacebook } from "react-icons/ci";
import { FaInstagram } from "react-icons/fa";
import { CiLinkedin } from "react-icons/ci";
import { Link } from "react-router-dom";
function Contact() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    countryCode: "+44", // ✅ added
    phone: "",
    message: "",
    acceptTerms: false,
  });

  const [errors, setErrors] = useState({});
  const [isSending, setIsSending] = useState(false);

  // ✅ Country code dropdown list
  const countryCodes = [
    { code: "+91", name: "India" },
    { code: "+44", name: "UK" },
    { code: "+1", name: "USA" },
    { code: "+61", name: "Australia" },
    { code: "+971", name: "UAE" },
    { code: "+92", name: "Pakistan" },
    { code: "+880", name: "Bangladesh" },
  ];

  // ✅ Regex patterns
  const nameRegex = /^[A-Za-z\s]+$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const phoneRegex = /^[0-9]{6,16}$/;

  // ✅ Terms popup
  const handleOpenTerms = () => {
    Swal.fire({
      title: "Terms & Conditions",
      html: `
      <div style="text-align:left; font-size:14px; line-height:1.7;">
        <p><b>Terms & conditions</b><br/>By submitting this form, you agree to the following terms:</p>

        <p><b>Purpose of Contact:</b><br/>
        This form is intended solely for inquiries related to Affinity's services and operations. Any inappropriate, unrelated, or malicious submissions may be disregarded.</p>

        <p><b>Accuracy of Information:</b><br/>
        You affirm that the information you provide is accurate and truthful. Misrepresentation or false claims may result in no response or further action.</p>

        <p><b>Data Usage and Privacy:</b><br/>
        Your personal information will be used only to respond to your inquiry and improve our services. Affinity adheres to applicable data protection laws and will not share your details with third parties without your consent unless required by law.</p>

        <p><b>Response Time:</b><br/>
        While we strive to respond promptly, response times may vary depending on the nature of your inquiry.</p>

        <p><b>Prohibited Submissions:</b><br/>
        Submissions containing offensive language, spam, or irrelevant content will be disregarded.</p>

        <p><b>Legal Compliance:</b><br/>
        This form must not be used to bypass legal procedures or submit unauthorized claims or complaints against Affinity.</p>
      </div>
    `,
      width: 800,
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: "I Agree",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#00652e",
      cancelButtonColor: "#6c757d",
      customClass: {
        popup: "terms-popup",
      },
    });
  };

  // ✅ Field validation
  const validateField = (name, value) => {
    let error = "";

    if (name === "fullName") {
      if (!value.trim()) error = "Full Name is required";
      else if (!nameRegex.test(value)) error = "Only alphabets are allowed";
    }

    if (name === "email") {
      if (!value.trim()) error = "Email is required";
      else if (!emailRegex.test(value)) error = "Enter a valid email address";
    }

    if (name === "countryCode") {
      if (!value) error = "Country code is required";
    }

    if (name === "phone") {
      if (!value.trim()) error = "Phone Number is required";
      else if (!phoneRegex.test(value))
        error = "Phone must be 6-16 digits (numbers only)";
    }

    if (name === "service") {
      if (!value) error = "Please select a service";
    }

    if (name === "message") {
      if (!value.trim()) error = "Message is required";
      else if (value.trim().length < 15)
        error = "Message must be at least 15 characters";
    }

    if (name === "acceptTerms") {
      if (!value) error = "Please accept the Terms & Conditions";
    }

    return error;
  };

  // ✅ Validate whole form
  const validateForm = () => {
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const err = validateField(key, formData[key]);
      if (err) newErrors[key] = err;
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ✅ Input change + realtime error show
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    const fieldValue = type === "checkbox" ? checked : value;

    setFormData((prev) => ({ ...prev, [name]: fieldValue }));

    setErrors((prev) => ({
      ...prev,
      [name]: validateField(name, fieldValue),
    }));
  };

  // ✅ EmailJS Send
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please fix the errors before submitting.",
      });
      return;
    }

    setIsSending(true);

    try {
      const SERVICE_ID = "service_gel8mpr";
      const TEMPLATE_ID = "template_ivyp65j";
      const PUBLIC_KEY = "egykh9C2MGnWK918j";

      const fullPhone = `${formData.countryCode} ${formData.phone}`; // ✅ combined phone

      const templateParams = {
        fullName: formData.fullName,
        email: formData.email,
        phone: fullPhone, // ✅ sending with country code
        service: formData.service,
        message: formData.message,
      };

      await emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY);

      Swal.fire({
        icon: "success",
        title: "Thank you for contacting ",
        text: "Affinity Childrens Team will get back to you soon.",
        confirmButtonColor: "#00652e",
      });

      setFormData({
        fullName: "",
        email: "",
        countryCode: "+91",
        phone: "",
        service: "",
        message: "",
        acceptTerms: false,
      });

      setErrors({});
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed to Send!",
        text: "Something went wrong. Please try again later.",
      });
    } finally {
      setIsSending(false);
    }
  };

  return (
    <>
      {/* Banner */}

      <section className="contact-banne text-center mobile-view">
        <div>
          <img src={BannerImg} className="w-100" />
        </div>
        <div className="container mobile-view-none">
          <div className="breadcrumb-container" aria-label="Breadcrumb">
            <ul className="breadcrumbs">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li aria-current="page">Contact Us</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-5 mt-5">
        <div className="container">
          <div className="row g-4 align-items-stretch">
            {/* Form */}
            <div className="col-12 col-lg-7">
              <div className="card shadow contact-card">
                <div className="card-body p-4">
                  <h3 className="text-center mb-4">Contact Us</h3>

                  <form onSubmit={handleSubmit} noValidate>
                    <div className="row align-items-stretch">
                      {/* Full Name */}
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Full Name</label>
                        <input
                          type="text"
                          name="fullName"
                          value={formData.fullName}
                          onChange={handleChange}
                          className={`form-control ${
                            errors.fullName ? "is-invalid" : ""
                          }`}
                          placeholder="Enter your name"
                        />
                        {errors.fullName && (
                          <small className="text-danger">
                            {errors.fullName}
                          </small>
                        )}
                      </div>

                      {/* Email */}
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Email Address</label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className={`form-control ${
                            errors.email ? "is-invalid" : ""
                          }`}
                          placeholder="Enter your email"
                        />
                        {errors.email && (
                          <small className="text-danger">{errors.email}</small>
                        )}
                      </div>

                      {/* Phone */}
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Phone Number</label>

                        <div className="input-group">
                          <select
                            className={`form-select ${
                              errors.countryCode ? "is-invalid" : ""
                            }`}
                            name="countryCode"
                            value={formData.countryCode}
                            onChange={handleChange}
                            style={{ maxWidth: "90px" }}
                          >
                            {countryCodes.map((item, index) => (
                              <option key={index} value={item.code}>
                                {item.code}
                              </option>
                            ))}
                          </select>

                          <input
                            type="tel"
                            name="phone"
                            value={formData.phone}
                            onChange={(e) => {
                              const onlyDigits = e.target.value.replace(
                                /\D/g,
                                "",
                              );
                              setFormData((prev) => ({
                                ...prev,
                                phone: onlyDigits,
                              }));

                              setErrors((prev) => ({
                                ...prev,
                                phone: validateField("phone", onlyDigits),
                              }));
                            }}
                            className={`form-control ${
                              errors.phone ? "is-invalid" : ""
                            }`}
                            placeholder="Enter phone number"
                            maxLength={16}
                          />
                        </div>

                        {errors.phone && (
                          <small className="text-danger d-block">
                            {errors.phone}
                          </small>
                        )}
                      </div>

                      {/* Post Code */}
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Post Code</label>
                        <input
                          type="text"
                          name="PostCode"
                          value={formData.PostCode}
                          onChange={handleChange}
                          className={`form-control ${
                            errors.PostCode ? "is-invalid" : ""
                          }`}
                          placeholder="Enter your Post Code"
                        />
                        {errors.PostCode && (
                          <small className="text-danger">
                            {errors.PostCode}
                          </small>
                        )}
                      </div>

                      {/* Checkbox Section */}
                      <div className="col-md-6 mb-3 d-flex">
                        <div className="w-100 h-100 d-flex flex-column">
                          <label className="form-label">
                            Why are you getting in touch?
                          </label>

                          <div className="flex-grow-1">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                              />
                              <label className="form-check-label">
                                I'm interested in a job
                              </label>
                            </div>

                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                              />
                              <label className="form-check-label">
                                Refereal for child
                              </label>
                            </div>

                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                              />
                              <label className="form-check-label">
                                Safe Guarding Issue
                              </label>
                            </div>

                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                              />
                              <label className="form-check-label">
                                Other (please leave a message)
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Message Section */}
                      <div className="col-md-6 mb-3 d-flex">
                        <div className="w-100 h-100 d-flex flex-column">
                          <label className="form-label">Message</label>

                          <textarea
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            className={`form-control flex-fill ${
                              errors.message ? "is-invalid" : ""
                            }`}
                            placeholder="Type your message..."
                            style={{ resize: "none" }}
                          />

                          {errors.message && (
                            <small className="text-danger">
                              {errors.message}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Terms */}
                    <div className="mb-3">
                      <div className="form-check">
                        <input
                          className={`form-check-input ${
                            errors.acceptTerms ? "is-invalid" : ""
                          }`}
                          type="checkbox"
                          id="acceptTerms"
                          name="acceptTerms"
                          checked={formData.acceptTerms}
                          onChange={handleChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="acceptTerms"
                        >
                          By clicking on this i agree to the{" "}
                          <span
                            onClick={handleOpenTerms}
                            style={{
                              color: "#00652e",
                              fontWeight: "600",
                              cursor: "pointer",
                              textDecoration: "underline",
                            }}
                          >
                            Terms and Condition
                          </span>
                        </label>
                      </div>

                      {errors.acceptTerms && (
                        <small className="text-danger">
                          {errors.acceptTerms}
                        </small>
                      )}
                    </div>

                    {/* Button */}
                    <div className="d-grid">
                      <button
                        type="submit"
                        className="btn custom-send-btn"
                        disabled={isSending}
                      >
                        {isSending ? "Sending..." : "Send Message"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>

              {/* Address */}
              <div className="my-4">
                <div className="card border-0 shadow-sm rounded-4">
                  <div className="card-body p-3">
                    <div className="d-flex align-items-start gap-3">
                      <span className="rounded-pill px-3 py-2">
                        <LuMapPin />
                      </span>

                      <div>
                        <h6 className="mb-1 fw-semibold">Address Location</h6>
                        <p className="mb-0 text-muted small">
                          The Old Coach House, Horse Fair, Rugeley
                          Staffordshire, England WS15 2EL
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Image */}
            <div className="col-12 col-lg-5">
              <div className="contact-img-wrap h-100">
                <img
                  src={contactImg}
                  alt="Contact"
                  className="img-fluid contact-img m-none"
                />

                <div className="card border-0 shadow-sm rounded-4 ">
                  <div className="card-body my-4 m-none">
                    <div className="d-flex align-items-start">
                      <span className="rounded-pill py-2">
                        <a
                          href="https://www.linkedin.com/company/affinity-childrens-services-ltd/"
                          target="_blank"
                        >
                          <img src={Linkedin} className="social-icon" />
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
